export class TurnoYaCalificadoError extends Error {
  constructor(serverMessage) {
    super(serverMessage || 'Este turno ya fue calificado.');
    this.name = 'TurnoYaCalificadoError';
  }
}
